import { render, staticRenderFns } from "./CompositeRow.vue?vue&type=template&id=72b11924"
import script from "./CompositeRow.vue?vue&type=script&setup=true&lang=js"
export * from "./CompositeRow.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports